<!--
  Faq — lista accordion de perguntas frequentes. Replica o visual de
  OligoscanLanding.vue > .secao-faq > .faq-grid.

  Props:
    - items : Array<{ question: string, answer: string }>
    - defaultAberto : number | null — índice inicialmente aberto

  Uso:
    <Faq :items="t.faqItems" />
-->
<template>
  <div class="faq-grid">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="faq-item"
      :class="{ active: ativo === index }"
      @click="toggle(index)"
    >
      <div class="faq-question">
        <span>{{ item.question }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="faq-icon">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </div>
      <div class="faq-answer">
        <p>{{ item.answer }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  items: { type: Array, required: true },
  defaultAberto: { type: Number, default: null }
})

const ativo = ref(props.defaultAberto)

const toggle = (i) => {
  ativo.value = ativo.value === i ? null : i
}
</script>

<style scoped>
.faq-grid {
  max-width: 780px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--ds-s-3);
}

.faq-item {
  background: var(--ds-surface-1);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-r-md);
  overflow: hidden;
  transition: all var(--ds-t-base);
  cursor: pointer;
}

.faq-item:hover {
  border-color: var(--ds-border-strong);
}

.faq-item.active {
  border-color: rgba(20, 203, 240, 0.4);
  background: rgba(20, 203, 240, 0.04);
}

.faq-question {
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--ds-font-bold);
  font-size: 15px;
  color: var(--ds-text);
  gap: 12px;
}

.faq-icon {
  color: var(--ds-text-dim);
  transition: transform var(--ds-t-base);
  flex-shrink: 0;
}

.faq-item.active .faq-icon {
  transform: rotate(180deg);
  color: var(--ds-accent);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease-out, padding var(--ds-t-base);
  padding: 0 22px;
}

.faq-item.active .faq-answer {
  max-height: 400px;
  padding: 0 22px 20px;
}

.faq-answer p {
  color: var(--ds-text-muted);
  line-height: 1.65;
  font-size: 14px;
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid var(--ds-border-subtle);
}
</style>
